import type { OwnedEntry } from "@/modules/transaksi/domain/types-ownership"

const PREFIKS_HASH = "#mig="
const MAKS_ENTRI_TOKEN = 100
const MAKS_ENTRI_LEGACY = 300
const MAKS_PANJANG_ID = 100
const MAKS_PANJANG_TOKEN = 200
const MAKS_PANJANG_USERNAME = 100

export interface MuatanMigrasiDomain {
  owned: OwnedEntry[]
  legacy: string[]
}

function dekodeBase64Url(nilai: string): unknown {
  try {
    const base64 = nilai.replace(/-/g, "+").replace(/_/g, "/")
    const bytes = Uint8Array.from(atob(base64), (karakter) => karakter.charCodeAt(0))
    return JSON.parse(new TextDecoder().decode(bytes))
  } catch {
    return null
  }
}

function bersihkanEntriToken(mentah: unknown): OwnedEntry[] {
  if (!Array.isArray(mentah)) return []

  return mentah
    .filter((item) => item && typeof item.transactionId === "string" && typeof item.token === "string")
    .slice(0, MAKS_ENTRI_TOKEN)
    .map((item) => ({
      transactionId: item.transactionId.slice(0, MAKS_PANJANG_ID),
      token: item.token.slice(0, MAKS_PANJANG_TOKEN),
      username: typeof item.username === "string" ? item.username.slice(0, MAKS_PANJANG_USERNAME) : undefined,
    }))
}

function bersihkanIdLegacy(mentah: unknown): string[] {
  if (!Array.isArray(mentah)) return []
  return mentah
    .filter((id): id is string => typeof id === "string")
    .slice(0, MAKS_ENTRI_LEGACY)
    .map((id) => id.slice(0, MAKS_PANJANG_ID))
}

export function bacaMuatanMigrasiDomain(): MuatanMigrasiDomain | null {
  if (typeof window === "undefined") return null

  const { hash, pathname, search } = window.location
  if (!hash.startsWith(PREFIKS_HASH)) return null

  window.history.replaceState(null, "", pathname + search)

  const payload = dekodeBase64Url(hash.slice(PREFIKS_HASH.length)) as { owned?: unknown; legacy?: unknown } | null
  if (!payload || typeof payload !== "object") return null

  return {
    owned: bersihkanEntriToken(payload.owned),
    legacy: bersihkanIdLegacy(payload.legacy),
  }
}
